import styled from "styled-components";

export const DesktopView = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    background-image: url(${(props) => props.bgImg});
`;

export const View = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #fff;
    display: flex;
    justify-content: center;
`

export const AnimateButton = styled.button`
    width: 4em;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4em;
    overflow: hidden;
    background: unset;
    border-radius: 5em;
    transition: all .15s ease;
    cursor: pointer;
    border: 3px solid #ffffff9a;
    position: absolute;
    left: 2em;
    bottom: 2em;
    &:hover {
    background: #ffffff9a;
    }
`

export const Background = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    background-image: url(${(props) => props.bgImg});
`

export const CrossShadow = styled.div`
    width: 100%;
    height: 7em;
    position: absolute;
    transform: translateY(-100%);
`

export const NavBar = styled.nav`
    width: 100%;
    height: 4em;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
`

export const Text = styled.text`
    position:${(props) => props.position};
    font-size:${(props) => props.size}em;
`

export const MsInfo = styled.div`
    position: absolute;
    text-align:${(props) => props.textAlign};
    padding:${(props) => props.pad}em;
    z-index:${(props) => props.zIndex};
    top:${(props) => props.top}em;
    bottom:${(props) => props.bottom}em;
    left:${(props) => props.botom}em;
    left:${(props) => props.left}em;
    right:${(props) => props.right}em;
`

export const Blur = styled.div`
    text-align: center;
    margin: 0 auto;
    display: ${(props) => props.display};
    align-items: ${(props) => props.align};
    justify-content: ${(props) => props.justify};
    width:${(props) => props.size}em;
    margin-top:${(props) => props.mt}em;
    float:${(props) => props.float};
    background:${(props) => props.background};
    border-radius: ${(props) => props.radius}em;
    backdrop-filter: blur(${(props) => props.blur}em);
    padding-top:${(props) => props.py}em;
    padding-bottom:${(props) => props.py}em;
    padding-left:${(props) => props.px}em;
    padding-right:${(props) => props.px}em;
    z-index:${(props) => props.zIndex};
    text-align:${(props) => props.textAlign};
`

export const Overlay = styled.div`
    // display: flex;
    // justify-content: center;
    text-align: center;
    padding-top: 4em;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: #1b1e21f4;
`

export const Object = styled.div`
    display: ${(props) => props.display};
    align-items: ${(props) => props.align};
    justify-content: ${(props) => props.justify};
    width:${(props) => props.size}em;
    position:${(props) => props.position};
    margin-top:${(props) => props.mt}em;
    float:${(props) => props.float};
    margin-left:${(props) => props.ml}em;
    box-shadow:${(props) => props.shadow};
    background:${(props) => props.background};
    border-radius: ${(props) => props.radius}em;
    backdrop-filter: blur(${(props) => props.blur}em);
    padding-top:${(props) => props.py}em;
    padding-bottom:${(props) => props.py}em;
    padding-left:${(props) => props.px}em;
    padding-right:${(props) => props.px}em;
    z-index:${(props) => props.zIndex};
    background-position: center;
    background-size: cover;
    position:${(props) => props.position};
    top:${(props) => props.top}em;
    bottom:${(props) => props.bottom}em;
    left:${(props) => props.botom}em;
    left:${(props) => props.left}em;
    right:${(props) => props.right}em;
    background-image: url(${(props) => props.bgImg});
    text-align:${(props) => props.textAlign};
`

export const Button = styled.button`
    display: ${(props) => props.display};
    align-items: ${(props) => props.align};
    justify-content: ${(props) => props.justify};
    width:${(props) => props.size}em;
    margin-top:${(props) => props.mt}em;
    float:${(props) => props.float};
    margin-left:${(props) => props.ml}em;
    box-shadow:${(props) => props.shadow};
    background:${(props) => props.background};
    border-radius: ${(props) => props.radius}em;
    backdrop-filter: blur(${(props) => props.blur}em);
    padding-top:${(props) => props.py}em;
    padding-bottom:${(props) => props.py}em;
    padding-left:${(props) => props.px}em;
    padding-right:${(props) => props.px}em;
    z-index:${(props) => props.zIndex};
    background-position: center;
    background-size: cover;
    border: none;
    position:${(props) => props.position};
    background-image: url(${(props) => props.bgImg});
    text-align:${(props) => props.textAlign};
    top:${(props) => props.top}em;
    bottom:${(props) => props.bottom}em;
    left:${(props) => props.botom}em;
    left:${(props) => props.left}em;
    right:${(props) => props.right}em;
    cursor:${(props) => props.cursor};
    border: 2px solid #ffffff00;
    &:hover {
    background: #ffffff7a;
    border: 2px solid #ffffff5a;
    }
`

export const Image = styled.img`
    position:${(props) => props.position};
    width:${(props) => props.size}em;
    scale:${(props) => props.scale};
`

export const Input = styled.input`
    width:${(props) => props.size}em;
`